import { Component } from 'react';

export class HelpSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                data-testid="help"
                width="41"
                height="40"
                viewBox="0 0 41 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M21.008 30.5791C27.0707 30.5791 31.9854 25.6974 31.9854 19.6756C31.9854 13.6538 27.0707 8.77209 21.008 8.77209C14.9454 8.77209 10.0306 13.6538 10.0306 19.6756C10.0306 21.6734 10.5716 23.5457 11.5159 25.1559L9.0144 31.2279L15.4016 29.0518C17.0425 30.0219 18.9598 30.5791 21.008 30.5791Z"
                    fill="white"
                    stroke="#1C5296"
                    strokeWidth="2"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.3003 23.584H18.5887"
                    stroke="#FB534A"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    d="M15.05 19.5967H27.4499"
                    stroke="#FB534A"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    d="M15.05 15.4636H27.4499"
                    stroke="#FB534A"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <circle cx="22.0993" cy="23.5839" r="0.952766" fill="#FB534A" />
            </svg>
        );
    }
}
